//基础信息
export default [
  {
    path: '/demo',
    component: () => import('../pages/restManage/demo.vue'),
    name: 'DiningRoom',
    title: '餐厅管理',
    meta: {
      title: '餐厅管理',
    },
  },
  {
    path: '/diningRoom',
    component: () => import('../pages/restManage/diningRoom.vue'),
    name: 'DiningRoom',
    title: '餐厅管理',
    meta: {
      title: '餐厅管理',
    },
  },
  {
    path: '/lifeManage',
    component: () => import('../pages/restManage/lifeManage.vue'),
    name: 'lifeManage',
    title: '生活管理',
    meta: {
      title: '生活管理',
    },
  },
  {
    path: '/lifeServiceManage',
    component: () => import('../pages/restManage/lifeServiceManage.vue'),
    name: 'lifeServiceManage',
    title: '生活服务',
    meta: {
      title: '生活服务',
    },
  },
  {
    path: '/lifePackageOrderManage',
    component: () => import('../pages/restManage/lifePackageOrderManage.vue'),
    name: 'lifePackageOrderManage',
    title: '服务订单管理',
    meta: {
      title: '服务订单管理',
    },
  },

  {
    path: '/diningFoodManage',
    component: () => import('../pages/restManage/diningFoodManage.vue'),
    name: 'diningFoodManage',
    title: '餐品管理',
    meta: {
      title: '餐品管理',
    },
  },
  {
    path: '/appointmentManage',
    component: () => import('../pages/restManage/appointmentManage.vue'),
    name: 'AppointmentManage',
    title: '预约管理',
    meta: {
      title: '预约管理',
    },
  },
  {
    path: '/cusineClassifyManage',
    component: () => import('../pages/restManage/cusineClassifyManage.vue'),
    name: 'CusineClassifyManage',
    title: '菜品分类管理',
    meta: {
      title: '菜品分类管理',
    },
  },
  {
    path: '/cuisineManage',
    component: () => import('../pages/restManage/cuisineManage.vue'),
    name: 'CuisineManage',
    title: '菜品管理',
    meta: {
      title: '菜品管理',
    },
  },
  {
    path: '/diningOrderList',
    component: () => import('../pages/restManage/diningOrderList.vue'),
    name: 'DiningrderList',
    title: '订单列表',
    meta: {
      title: '订单列表',
    },
  },
  {
    path: '/addDiningRoom',
    component: () => import('../pages/restManage/addDiningRoom.vue'),
    name: 'AddDiningRoom',
    title: '添加餐厅',
    meta: {
      title: '添加餐厅',
    },
  },
  {
    path: '/changeDiningRoom',
    component: () => import('../pages/restManage/changeDiningRoom.vue'),
    name: 'ChangeDiningRoom',
    title: '修改餐厅',
    meta: {
      title: '修改餐厅',
    },
  },
  {
    path: '/restOrder',
    component: () => import('../pages/restManage/restOrder.vue'),
    name: 'restOrder',
    title: '餐厅订单',
    meta: {
      title: '餐厅订单',
    },
  },
  {
    path: '/deskManage',
    component: () => import('../pages/restManage/deskManage.vue'),
    name: 'deskManage',
    title: '餐桌管理',
    meta: {
      title: '餐桌管理',
    },
  },
  {
    path: '/testHeart',
    component: () => import('../pages/restManage/test2.vue'),
    name: 'testHeart',
    title: '测试',
    meta: {
      title: '测试',
    },
  },
  /**
   * 美食套餐管理模块
   * 套餐上线管理：同畅玩票务管理
   * 套餐配置日历（每个套餐配置上线时间）
   */
  {
    path: '/packageUplineManage',
    component: () => import('../pages/restManage/packageUplineManage.vue'),
    name: 'packageUplineManage',
    title: '套餐上线管理',
    meta: {
      title: '套餐上线管理',
    },
  },
  {
    path: '/catePackageOrderManage',
    component: () => import('../pages/restManage/restOrderManage.vue'),
    name: 'catePackageOrderManage',
    title: '套餐订单管理',
    meta: {
      title: '套餐订单管理',
    },
  },
]
